module.exports = __webpack_public_path__ + "blur-bg.a42873d95a26afc7eb31.png";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/assets/images/widget/blur-bg.png
// module id = ../../../../../src/assets/images/widget/blur-bg.png
// module chunks = styles